import { API_URL } from './config';
import { auth } from '../firebase/config';
import { apiFetch } from './apiFetch';

export const sendReceipt = async (orderId: string, type: 'success' | 'unsuccess') => {
  try {
    const idToken = await auth.currentUser?.getIdToken();

    const response = await apiFetch(`${API_URL}/sendReceipt/${orderId}?type=${type}`, {
      method: 'POST',
      headers: {
        ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
      },
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.log(err);
  }
};
